import { isIdle, isLoading, isRejected } from '../../common/types/FetchStatus';
import { useAssociatedObjectsRecord } from './useAssociatedObjectsRecord';
import { Link } from 'foundations-components/transitional/components/Link';
import GenericLink from './GenericLink';
import { getRecordHref } from './getRecordHref';
import { jsx as _jsx } from "react/jsx-runtime";
const AssociatedRecordLink = ({
  children,
  includeEschref = false,
  LinkComponent = Link,
  LinkComponentProps = {},
  objectId,
  objectTypeId,
  handleClick
}) => {
  const associatedRecord = useAssociatedObjectsRecord(objectTypeId, objectId);
  if (isIdle(associatedRecord) || isLoading(associatedRecord) || isRejected(associatedRecord) || !associatedRecord.data) {
    return /*#__PURE__*/_jsx("strong", {
      children: children
    });
  }
  const href = getRecordHref(associatedRecord.data.objectTypeId, associatedRecord.data.objectId, {
    includeEschref
  });
  return /*#__PURE__*/_jsx(GenericLink, {
    LinkComponent: LinkComponent,
    LinkComponentProps: LinkComponentProps,
    dataSpeculationTarget: "crm-links-CRM_OBJECT_RECORD",
    external: true,
    href: href,
    onClick: handleClick,
    children: children
  });
};
export default AssociatedRecordLink;